import { css } from '@emotion/react';
import sctheme from 'app/styles/sctheme';

const styles = sctheme => css`
  background-color: ${sctheme.system.infoLight};
  border: 1px solid ${sctheme.system.info};
  color: ${sctheme.black};
  padding: 1rem;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;

  .icon {
    color: ${sctheme.system.info};
    margin-right: 0.5rem;
    margin-top: 4px;
  }
`;

export default styles(sctheme);
